// extracted by mini-css-extract-plugin
module.exports = {"vehiclePreviewGrid":"vehicle-preview_vehiclePreviewGrid__dJqS6","withEdit":"vehicle-preview_withEdit__arJ9I","overflowText":"vehicle-preview_overflowText__T3oSI"};